import C from 'actionTypes'
import { addRecord, setRecords, editRecord } from 'utils/reducerUtils'

const defaultState = {
  contacts: []
}

const contacts = (state = defaultState, action) => {
  switch (action.type) {
    case C.ADD_CONTACT: {
      return addRecord(state, action, 'contacts')
    }
    case C.SET_CONTACTS: {
      return setRecords(state, action, 'contacts')
    }
    case C.EDIT_CONTACT: {
      return editRecord(state, action, 'contacts')
    }
    default:
      return state
  }
}

export default contacts



// WEBPACK FOOTER //
// ./src/reducers/contacts.js